export default __webpack_public_path__ + "static/media/avatar2.f24a2d3c.png";